import { fechaLarga, precio, duracion } from '../lib/formato.js';
import { POR_DEFECTO } from '../lib/vocabulario.js';

/**
 * Lo elegido hasta acá, para no tener que volver atrás a verificar.
 *
 * El rótulo de lo reservado sale del rubro: «Con: Juan» en una barbería,
 * «Cancha: Cancha 2» en un club, donde «Con» sonaría a que la cancha lo
 * acompaña.
 */
export function Resumen({ servicio, profesional, fecha, slot, timezone, vocabulario = POR_DEFECTO }) {
  return (
    <div className="resumen">
      <div className="resumen-fila">
        <span className="resumen-etiqueta">Servicio</span>
        <span className="resumen-valor">
          {servicio.nombre}
          {servicio.precio_centavos > 0 && ` · ${precio(servicio.precio_centavos)}`}
        </span>
      </div>

      <div className="resumen-fila">
        <span className="resumen-etiqueta">{vocabulario.etiquetaTurno}</span>
        <span className="resumen-valor">{profesional.nombre}</span>
      </div>

      <div className="resumen-fila">
        <span className="resumen-etiqueta">Cuándo</span>
        <span className="resumen-valor destacado">
          {fechaLarga(fecha, timezone)} a las {slot.hora}
        </span>
      </div>

      <div className="resumen-fila">
        <span className="resumen-etiqueta">Duración</span>
        <span className="resumen-valor">{duracion(servicio.duracion_minutos)}</span>
      </div>
    </div>
  );
}
